export default `float de(vec3 p){
    for(int j=0;++j<8;)
      p.z-=.3,
      p.xz=abs(p.xz),
      p.xz=(p.z>p.x)?p.zx:p.xz,
      p.xy=(p.y>p.x)?p.yx:p.xy,
      p.z=1.-abs(p.z-1.),
      p=p*3.-vec3(10.0,4.0,2.0);

    return length(p)/6e3-.001;
  }`